const updateEquipmentServices = {
  toastr: 'Servicio actualizado',
  toastrError: 'Tipo de servicio ya registrado',
  toastrError1: 'Ingrese otro nombre'
};

export default updateEquipmentServices;
